import {GenericInput, Pagination, Table, useSortableTable} from '@hm/fundamental'
import {mdiMagnify} from '@mdi/js'
import {useMemo, useState} from 'react'
import {useTranslation} from 'react-i18next'

import {useFiltersContext} from '../../providers/FiltersProvider'

import {UpmDepartmentWithPlant} from '@refra/modules/refra-flexible-report/types'

export const KilnsReportTable = () => {
  const {t} = useTranslation()
  const {filteredKilns} = useFiltersContext()
  const [textFilter, setTextFilter] = useState('')
  const [paginationConfig, setPaginationConfig] = useState({
    pageNumber: 0,
    pageSize: 20
  })

  const config = useSortableTable<UpmDepartmentWithPlant>([
    {
      label: t('refraFlexibleReport.report.kilnsSection.columns.plant'),
      value: (department) => department.plantName
    },
    {
      label: t('refraFlexibleReport.report.kilnsSection.columns.kiln'),
      value: (department) => department.value
    }
  ])

  const filteredByTextKilns = useMemo(() => {
    const query = textFilter.trim().toLowerCase()

    if (!query) {
      return filteredKilns
    }

    return filteredKilns.filter((kiln) => {
      return (
        kiln.plantName?.toLowerCase().includes(query) || kiln.value?.toLowerCase().includes(query)
      )
    })
  }, [filteredKilns, textFilter])

  const paginatedKilns = useMemo(
    () =>
      filteredByTextKilns.slice(
        paginationConfig.pageNumber * paginationConfig.pageSize,
        (paginationConfig.pageNumber + 1) * paginationConfig.pageSize
      ),
    [filteredByTextKilns, paginationConfig]
  )

  return (
    <div className="flex flex-col gap-4">
      <GenericInput
        name="refra_kilns_text_filter"
        defaultValue={textFilter}
        icon={mdiMagnify}
        placeholder={t('refraFlexibleReport.report.kilnsSection.filterPlaceholder')}
        onChange={(text) => {
          setTextFilter(text)
          setPaginationConfig((prev) => ({...prev, pageNumber: 0}))
        }}
        data-cy="refra_kilns_text_filter"
      />
      <Table config={config} data={paginatedKilns} />
      <Pagination
        label={''}
        totalItems={filteredByTextKilns.length}
        onChange={(pageNumber, pageSize) => setPaginationConfig({pageNumber, pageSize})}
        defaultPage={paginationConfig.pageNumber}
        defaultPageSize={paginationConfig.pageSize}
      />
    </div>
  )
}
